/* Keoki Shop - Home premium: aparicion suave de bloques al hacer scroll.
   Sin dependencias. Si el navegador no tiene IntersectionObserver o el
   usuario prefiere menos movimiento, todo se muestra sin animar. */
(function () {
  if (window.__kpHome) return;
  window.__kpHome = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('kp-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan(root) {
    (root || document).querySelectorAll('.kp [data-kp-reveal]:not(.is-in)').forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 4, 3) * 80 + 'ms';
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
